// Generated by CoffeeScript 2.7.0
var FilterOptions;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import ChipInput from 'trunks/vue/admin/components/libs/chip_input.js';

import GroupOptions from 'trunks/vue/admin/components/libs/group_options.js';

export default FilterOptions = Vue.extend({
  components: {
    Popover: Popover,
    GroupOptions: GroupOptions,
    ChipInput: ChipInput
  },
  props: {
    groupedOptions: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'bottom'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxSelectedOptionsLength: {
      type: Number,
      default: 2e308
    }
  },
  data: function() {
    return {
      options: [],
      keyword: ''
    };
  },
  template: `<Popover :position='position'
         :caret='false'
         :blockContent='true'
         ref='popoverVm'
         :disabled='disabled'
         @triggerClicked='triggerClicked'
         @beforeClose='clearKeyword'>
  <template slot='trigger'>
    <ChipInput :chips='selectedOptions'
               @chipClicked='unselect'
               @keywordChange='updateKeyword'
               :placeholder='placeholder'
               :readonly='disabled'
               ref='chipInput' />
  </template>
  <template slot='content'>
    <GroupOptions :groupedOptions='groupedOptions'
                  :keyword='keyword'
                  @valueChanged='valueChangedFunc'
                  :multiple='multiple'
                  ref='groupOptions'>
      <template slot='option-item-template' slot-scope='{ option }'>
        <slot name='option-item-template' :option='option'>
          <div class='tip icon'>
            <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
          </div>
          <div class='content'>{{ option.name }}</div>
        </slot>
      </template>
      <template slot='options-blankslate'>
        <slot name='options-blankslate'>
          <div class='list-group'>
            <div class='list-group-name'>没有你想要的</div>
          </div>
        </slot>
      </template>
      <template slot='filter-blankslate'>
        <slot name='filter-blankslate'>
          <div class='list-group'>
            <div class='list-group-name'>没有你想要的</div>
          </div>
        </slot>
      </template>
    </GroupOptions>
  </template>
</Popover>`,
  computed: {
    selectedOptions: function() {
      return _.chain(this.groupedOptions).map(function(group) {
        return _.select(group.options, function(option) {
          return option._selected;
        });
      }).flatten().value();
    }
  },
  // what's reason it exist?
  // mounted: ->
  //   @valueChangedFunc()
  methods: {
    clearKeyword: function() {
      this.keyword = '';
      return this.$refs.chipInput.clear();
    },
    triggerClicked: function(event) {
      if (event.target === this.$refs.chipInput.$refs.input.$el) {
        return this.$refs.popoverVm.open();
      }
    },
    updateKeyword: function(keyword) {
      return this.keyword = keyword;
    },
    valueChangedFunc: function(vm, option) {
      if (this.selectedOptions.length > this.maxSelectedOptionsLength) {
        option._selected = false;
        return this.$emit('valueError');
      } else {
        this.$emit('valueChanged', this);
        return this.$nextTick(function() {
          return this.$refs.chipInput.resize();
        });
      }
    },
    toggleOption: function(option) {
      option._selected = !option._selected;
      return this.valueChangedFunc(option);
    },
    unselect: function(option) {
      if (this.$refs.groupOptions) {
        return this.$refs.groupOptions.unselect(option);
      } else {
        return this.toggleOption(option);
      }
    }
  }
});
